export default {"src":"/_next/static/media/right_curve_arrow.978818b5.svg","height":7,"width":19,"blurWidth":0,"blurHeight":0};